<template>
 <div id="platform-view" class="minHeight">
   <section class="section-1">
      <i-title :titleOne="'平台资质'" :titleTwo="'被认可不是荣耀，是继续前进的动力'"></i-title>
      <div class="platform-list">
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index">
            <a :href="require('../../assets/images/' + item.imgName + '.jpg')" target="_blank">
              <img :src="require('../../assets/images/' + item.imgName + '.jpg')">
            </a>
            <span>{{item.text}}</span>
          </li>
        </ul>
      </div>
   </section>
   <autograph></autograph>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import informationTitle from '@/components/informationTitle'
export default {
  data () {
    return {
      list: [
        {
          imgName: 'yyzz',
          text: '营业执照副本'
        }, {
          imgName: 'zzjgdmz',
          text: '组织机构代码证'
        // }, {
        //   imgName: 'jrxx',
        //   text: '监管部门批文'
        }, {
          imgName: 'cshy',
          text: '北京市互联网金融行业协会'
        }, {
          imgName: '315',
          text: '行业荣誉'
        }, {
          imgName: 'hlwrz',
          text: '互联网金融网站证书'
        }
      ]
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  components: {
    'autograph': autograph,
    'i-title': informationTitle
  }
}
</script>

<style lang="less">
#platform-view{
  width:980px;
  float: left;
  overflow: hidden;
  background: #fff;
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  .section-1{
    .platform-list{
      ul{
        width: 780px;
        margin :0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li{
          width: 182px;
          height: 300px;
          margin-bottom: 100px;
          margin-left: 20px;
          background-color: #fff;
          text-align: center;
          img{
            width: 180px;
            height: 250px;
            margin-bottom: 20px;
            border: 1px solid #eee;
            cursor: pointer;
          }
          span{
            font-size: 14px;
            color: #323232;
          }
        }
        li:last-child{
          img{
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/platform.vue